/* eslint-disable */
import { Config } from "../Config";
import { FaceTecSDK } from "../../core-sdk/FaceTecSDK.js/FaceTecSDK";
import { LivenessCheckProcessor } from "./processors/LivenessCheckProcessor";
import { SampleAppUtilities } from "./utilities/LivenessUtilities";
import Service from '../services/Service';
import FaceTecStrings from '../../core-sdk-optional/FaceTecStrings';
export var SampleApp = (function () {
    var latestEnrollmentIdentifier = "";
    var latestProcessor;
    var initialized = false;
    function intialize(theme, productionKey) {
        //SampleAppUtilities.formatUIForDevice();
        // Set a the directory path for other FaceTec Browser SDK Resources.
        FaceTecSDK.setResourceDirectory("../../core-sdk/FaceTecSDK.js/resources");
        // Set the directory path for required FaceTec Browser SDK images.
        FaceTecSDK.setImagesDirectory("../../core-sdk/FaceTec_images");
        var customization = new FaceTecSDK.FaceTecCustomization();
        if (window.location !== window.parent.location) {
            var SDKInIFrameFeatureFlag = { ac_ziif: "991d6c1c-5e5c-4e32-89c7-1ddfac46572e" };
            // Initialize FaceTec Browser SDK and configure the UI features.
            //FaceTecSDK.initializeInProductionMode(Config.ProductionKeyText, Config.DeviceKeyIdentifier,Config.PublicFaceScanEncryptionKey,function(initializedSuccessfully) {
            customization = new FaceTecSDK.FaceTecCustomization([SDKInIFrameFeatureFlag]);
        }
        customization.cancelButtonCustomization.location = 0;
        customization.frameCustomization.borderColor = theme.backgroundColor;
        customization.frameCustomization.backgroundColor = theme.backgroundColor;
        customization.frameCustomization.borderWidth = "0px";
        customization.initialLoadingAnimationCustomization.backgroundColor = theme.primaryColor;
        customization.initialLoadingAnimationCustomization.foregroundColor = theme.primaryColor;
        customization.initialLoadingAnimationCustomization.messageTextColor = theme.primaryColor;
        // FaceTec Guidance
        var faceTecGuidanceCustomization = new FaceTecSDK.FaceTecGuidanceCustomization();
        faceTecGuidanceCustomization.readyScreenHeaderTextColor = theme.primaryColor;
        faceTecGuidanceCustomization.readyScreenHeaderFont = theme.fontFamily;
        faceTecGuidanceCustomization.backgroundColors = theme.backgroundColor;
        faceTecGuidanceCustomization.readyScreenSubtextFont = theme.fontFamily;
        faceTecGuidanceCustomization.readyScreenSubtextTextColor = theme.primaryColor;
        faceTecGuidanceCustomization.foregroundColor = theme.primaryTextColor;
        faceTecGuidanceCustomization.buttonBackgroundNormalColor = theme.primaryColor;
        faceTecGuidanceCustomization.buttonBackgroundHighlightColor = theme.primaryColor;
        faceTecGuidanceCustomization.buttonBackgroundDisabledColor = theme.primaryColor;
        faceTecGuidanceCustomization.buttonTextNormalColor = theme.buttonContentColor;
        faceTecGuidanceCustomization.buttonTextHighlightColor = theme.buttonContentColor;
        faceTecGuidanceCustomization.buttonTextDisabledColor = theme.buttonContentColor;
        faceTecGuidanceCustomization.retryScreenHeaderFont = theme.fontFamily;
        faceTecGuidanceCustomization.retryScreenSubtextFont = theme.fontFamily;
        faceTecGuidanceCustomization.buttonFont = theme.fontFamily;
        faceTecGuidanceCustomization.headerFont = theme.fontFamily;
        faceTecGuidanceCustomization.subtextFont = theme.fontFamily;
        customization.guidanceCustomization = faceTecGuidanceCustomization;
        // FaceTec Frame
        var faceTecFrameCustomization = new FaceTecSDK.FaceTecFrameCustomization();
        faceTecFrameCustomization.backgroundColor = theme.backgroundColor;
        faceTecFrameCustomization.borderColor = theme.backgroundColor;
        faceTecFrameCustomization.borderWidth = "0px";
        customization.frameCustomization = faceTecFrameCustomization;
        // FaceTec Overlay
        var faceTecOverlayCustomization = new FaceTecSDK.FaceTecOverlayCustomization();
        faceTecOverlayCustomization.backgroundColor = theme.backgroundColor;
        if (theme.secondaryLogo) {
            faceTecOverlayCustomization.brandingImage = theme.secondaryLogo;
        }
        else {
            faceTecOverlayCustomization.showBrandingImage = false;
        }
        customization.overlayCustomization = faceTecOverlayCustomization;
        // FaceTec Oval
        var faceTecOvalCustomization = new FaceTecSDK.FaceTecOvalCustomization();
        faceTecOvalCustomization.strokeColor = theme.primaryColor;
        faceTecOvalCustomization.progressColor1 = theme.primaryColor;
        faceTecOvalCustomization.progressColor2 = theme.primaryColor;
        customization.ovalCustomization = faceTecOvalCustomization;
        // FaceTec Feedback
        var faceTecFeedbackCustomization = new FaceTecSDK.FaceTecFeedbackBarCustomization();
        faceTecFeedbackCustomization.backgroundColor = theme.primaryColor;
        faceTecFeedbackCustomization.textFont = theme.fontFamily;
        faceTecFeedbackCustomization.textColor = theme.buttonContentColor;
        customization.feedbackCustomization = faceTecFeedbackCustomization;
        // FaceTec ResultScreen
        var faceTecResultScreenCustomization = new FaceTecSDK.FaceTecResultScreenCustomization();
        faceTecResultScreenCustomization.foregroundColor = theme.primaryColor;
        faceTecResultScreenCustomization.activityIndicatorColor = theme.primaryColor;
        faceTecResultScreenCustomization.uploadProgressFillColor = theme.primaryColor;
        faceTecResultScreenCustomization.uploadProgressTrackColor = theme.primaryColor;
        faceTecResultScreenCustomization.resultAnimationBackgroundColor = theme.primaryColor;
        faceTecResultScreenCustomization.resultAnimationForegroundColor = theme.primaryColor;
        faceTecResultScreenCustomization.backgroundColors = theme.backgroundColor;
        faceTecResultScreenCustomization.resultAnimationBackgroundColor = theme.backgroundColor;
        customization.resultScreenCustomization = faceTecResultScreenCustomization;
        // Audio
        customization.vocalGuidanceCustomization = {
            pleaseFrameYourFaceInTheOvalSoundFile: "../../core-sdk-optional/audio/please_frame_your_face_in_the_oval.mp3",
            pleaseMoveCloserSoundFile: "../../core-sdk-optional/audio/please_move_closer.mp3",
            pleasePressTheButtonToStartSoundFile: "../../core-sdk-optional/audio/please_press_the_button_to_start.mp3",
            facescanSuccessfulSoundFile: "",
            pleaseRetrySoundFile: "",
            uploadingSoundFile: "",
            mode: 0, // minimal mode
        };
        FaceTecSDK.setCustomization(customization);
        // Set localizations
        Config.initializeFromAutogeneratedConfig(FaceTecSDK, productionKey, function (initializedSuccessfully) {
            if (initializedSuccessfully) {
                //Start Localization Strings
                FaceTecSDK.configureLocalization(FaceTecStrings);
                initialized = true;
                //SampleAppUtilities.enableAllButtons();
                SampleAppUtilities.enableControlButtons();
                // Set the sound files that are to be used for Vocal Guidance.
                SampleAppUtilities.setVocalGuidanceSoundFiles();
                // Set the strings to be used for group names, field names, and placeholder texts for the FaceTec ID Scan User OCR Confirmation Screen.
                SampleAppUtilities.setOCRLocalization();
            }
            //SampleAppUtilities.displayStatus(FaceTecSDK.getFriendlyDescriptionForFaceTecSDKStatus(FaceTecSDK.getStatus()));
        });
    }
    // Wait for onload to be complete before attempting to access the Browser SDK.
    window.onload = function () {
        //intialize();
    };
    // Initiate a 3D Liveness Check.
    function onLivenessCheckPressed(form, step, formInfo, theme, navigate, dispatch, setLoading) {
        if (!initialized) {
            setLoading(true);
            intialize(theme, form.steps[step].fields.find(function (f) { return f.field === 'token_liveness_3d'; }).value.replace(/'/g, '"'));
        }
        //SampleAppUtilities.fadeOutMainUIAndPrepareForSession();
        // Get a Session Token from the FaceTec SDK, then start the 3D Liveness Check.
        getSessionToken(function (sessionToken) {
            window.setTimeout(function () {
                latestProcessor = new LivenessCheckProcessor(sessionToken, SampleApp, form, step, formInfo, navigate, dispatch, theme, setLoading);
            }, 5000);
        }, form, step, formInfo);
    }
    // Show the final result and transition back into the main interface.
    function onComplete() {
        SampleAppUtilities.showMainUI();
        if (!latestProcessor.isSuccess()) {
            // Reset the enrollment identifier.
            latestEnrollmentIdentifier = "";
            // Show early exit message to screen.  If this occurs, please check logs.
            SampleAppUtilities.displayStatus("Session exited early, see logs for more details.");
            return;
        }
        // Show successful message to screen
        SampleAppUtilities.displayStatus("Success");
    }
    // Get the Session Token from the server
    function getSessionToken(sessionTokenCallback, form, step, formInfo) {
        if (form === void 0) { form = null; }
        if (step === void 0) { step = null; }
        if (formInfo === void 0) { formInfo = null; }
        var value = {
            deviceKey: Config.DeviceKeyIdentifier,
            userAgent: FaceTecSDK.createFaceTecAPIUserAgentString("")
        };
        var params = {
            tokenOnboarding: (formInfo === null || formInfo === void 0 ? void 0 : formInfo.tokenOnboarding) || '',
            step: form.steps[step].step,
            field: "SESSION_ID_LIVENESS_3D",
            value: JSON.stringify(value)
        };
        Service.serviceField(params)
            .then(function (response) {
            var sessionToken = "";
            try {
                // Attempt to get the sessionToken from the response object.
                var resp = response;
                sessionToken = resp[0].value ? resp[0].value : "";
                // Something went wrong in parsing the response. Return an error.
                if (typeof sessionToken !== "string") {
                    onServerSessionTokenError();
                    return;
                }
            }
            catch (_a) {
                // Something went wrong in parsing the response. Return an error.
                onServerSessionTokenError();
                return;
            }
            sessionTokenCallback(sessionToken);
        }).catch(function () {
        });
    }
    function onServerSessionTokenError() {
        SampleAppUtilities.handleErrorGettingServerSessionToken();
    }
    //
    // DEVELOPER NOTE:  This is a convenience function for demonstration purposes only so the Sample App can have access to the latest session results.
    // In your code, you may not even want or need to do this.
    //
    function setLatestSessionResult(_sessionResult) {
    }
    function setIDScanResult(_idScanResult) {
    }
    function getLatestEnrollmentIdentifier() {
        return latestEnrollmentIdentifier;
    }
    function setLatestServerResult(_responseJSON) {
    }
    function onDesignShowcasePressed() {
        //ThemeHelpers.showNewTheme();
    }
    return {
        onLivenessCheckPressed: onLivenessCheckPressed,
        onDesignShowcasePressed: onDesignShowcasePressed,
        onComplete: onComplete,
        setLatestSessionResult: setLatestSessionResult,
        setIDScanResult: setIDScanResult,
        getLatestEnrollmentIdentifier: getLatestEnrollmentIdentifier,
        setLatestServerResult: setLatestServerResult
    };
})();
